import { RoomMaintenanceState } from '@ac/library-api';

export function isRoomReleasable(state?: RoomMaintenanceState): boolean {
  return !!state && [RoomMaintenanceState.Pending, RoomMaintenanceState.Active].includes(state);
}



// WEBPACK FOOTER //
// ./src/components/shared/Templates/Maintenance/MaintenanceReleaseForm/utils/utils.ts